<template>
    <section>
        <!-- Size small -->
        <o-breadcrumb size="small">
            <o-breadcrumb-item label="Home" href="/" />
            <o-breadcrumb-item label="Docs" disabled />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Size default -->
        <o-breadcrumb>
            <o-breadcrumb-item label="Home" href="/" />
            <o-breadcrumb-item label="Docs" disabled />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Size medium -->
        <o-breadcrumb size="medium">
            <o-breadcrumb-item label="Home" href="/" />
            <o-breadcrumb-item label="Docs" disabled />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Size large -->
        <o-breadcrumb size="large">
            <o-breadcrumb-item label="Home" href="/" />
            <o-breadcrumb-item label="Docs" disabled />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>
    </section>
</template>
